function syncSubscribeSaveUI(widget) {
  if (!widget) return;

  const sellingPlanIdInput = widget.querySelector('[data-bsub-selling-plan-id-input]');
  const selectedSellingPlan = sellingPlanIdInput ? sellingPlanIdInput.value : '';

  const buyButton = document.querySelector(
    'featured-product-information .product-information .product-details > .group-block > .group-block-content .buy-buttons-block .button[id^=BuyButtons-ProductSubmitButton-] .add-to-cart-text .add-to-cart-text__content span span'
  );
  const savingPriceElement = document.querySelector(
    '.subscribe-save-message'
  );
  const priceElement = document.querySelector(
    'featured-product-information product-price [ref="priceContainer"] .price'
  );

  if (buyButton) {
    buyButton.textContent = selectedSellingPlan ? 'Start Now' : 'Add To Cart';
  }

  if (savingPriceElement) {
    savingPriceElement.style.display = selectedSellingPlan ? 'block' : 'none';
  }

  if (priceElement) {
    if (selectedSellingPlan) {
      const selectedPlanEl = widget.querySelector(
        `[data-bsub-selling-plan][data-bsub-selling-plan-id="${selectedSellingPlan}"]`
      );
      const perDeliveryPriceEl = selectedPlanEl && selectedPlanEl.querySelector('[data-bsub-per-delivery-price]');

      if (perDeliveryPriceEl && perDeliveryPriceEl.textContent.trim()) {
        if (!priceElement.dataset.originalPrice) {
          priceElement.dataset.originalPrice = priceElement.textContent;
        }
        priceElement.textContent = perDeliveryPriceEl.textContent;
      }
    } else if (priceElement.dataset.originalPrice) {
      priceElement.textContent = priceElement.dataset.originalPrice;
    }
  }
}

document.addEventListener('change', function (event) {
  if (!event.target.matches('[data-bsub-selling-plan-group-input], [data-bsub-selling-plan-input]')) {
    return;
  }

  syncSubscribeSaveUI(event.target.closest('[data-bsub-widget]'));
});

document.addEventListener('DOMContentLoaded', function () {
  syncSubscribeSaveUI(document.querySelector('[data-bsub-widget]'));
});

(function () {
  function scrollToProduct() {
    var target = document.querySelector('featured-product-information');
    if (target) {
      var top = target.getBoundingClientRect().top + window.pageYOffset - 50;
      window.scrollTo({ top: top, behavior: 'smooth' });
      return true;
    }
    return false;
  }

  function waitAndScroll() {
    var attempts = 0;
    var interval = setInterval(function () {
      if (scrollToProduct() || attempts > 20) {
        clearInterval(interval);
        if (window.location.search.includes('buyNow')) {
          history.replaceState(null, '', '/');
        }
      }
      attempts++;
    }, 200);
  }

  // On page load — check for ?buyNow in URL
  if (window.location.search.includes('buyNow')) {
    waitAndScroll();
  }

  // Same-page click — catch ALL clicks on links containing buyNow
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="buyNow"]');
    if (!link) return;

    if (window.location.pathname === '/') {
      e.preventDefault();
      e.stopPropagation();
      scrollToProduct();
    }
  }, true); // <-- capture phase to fire BEFORE other handlers

  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href="#cookieSettings"]');
    if (link) {
      e.preventDefault();
      privacyBanner.showPreferences();
    }
  });

})();

